import { POSTCODE, SECTOR } from "./layers";

export const OVERLAY_LEVELS = {
  OUTER: "overlayOuter",
  SECTOR: "overlaySector",
  POSTCODE: "overlayPostcode",
};

export const ADD = "ADD";
export const ADD_REDIRECT = "ADD_REDIRECT";
export const REPLACE = "REPLACE";
export const REMOVE = "REMOVE";
export const REMOVE_REDIRECT = "REMOVE_REDIRECT";

export const REPLACE_LEVEL_ONLY = "REPLACE_LEVEL_ONLY";
export const REPLACE_ALL = "REPLACE_ALL";
export const REMOVE_TO_NONE = "REMOVE_TO_NONE";
export const REMOVE_TO_ABOVE = "REMOVE_TO_ABOVE";

export const LEVEL_TO_POSTCODE_KEY = {
  OUTER: "postcodeOuter",
  SECTOR: "postcodeSector",
  POSTCODE: "postcode",
};

export const LOWER_LEVELS = {
  OUTER: [SECTOR, POSTCODE],
  SECTOR: [POSTCODE],
  POSTCODE: [],
};

export const MAX_SECTORS = 30;

export const MAX_POSTCODES = 1200;

export const ZOOM_LEVELS = {
  OUTER: 9,
  SECTOR: 13,
};

export const MIN_ZOOM_FOR_AREA_LABEL = {
  0: 10.4,
  1: 10.14,
  2: 9.9,
  3: 9.75,
  4: 9.68,
  5: 9.415,
  6: 9.22,
  7: 8.89,
  8: 8.73,
  9: 8.6,
  10: 8.55,
  15: 8.45,
  20: 8.3,
  25: 8.2,
  30: 8.0,
  35: 7.9,
  40: 7.75,
  45: 7.65,
  50: 7.55,
  60: 7.45,
  70: 7.4,
  80: 7.35,
  90: 7.3,
  100: 7.25,
  110: 7.2,
  120: 7.15,
  130: 7.1,
  140: 7.05,
  150: 7.0,
  200: 6.85,
  300: 6.75,
  400: 6.6,
  500: 6.5,
  MAX: 6.4,
};

export const DEFAULT_FIT_BOUNDS = [
  [-7.57216793459, 49.959999905],
  [1.68153079591, 58.6350001085],
];

const sqmInSqKm = 1000000;
export const FIT_BOUNDS_AREA_PADDING = {
  OUTER: {
    [0.5 * sqmInSqKm]: 2.4,
    [2 * sqmInSqKm]: 2.5,
    [5 * sqmInSqKm]: 2.8,
    [10 * sqmInSqKm]: 3.1,
    [20 * sqmInSqKm]: 3.3,
    [30 * sqmInSqKm]: 3.5,
    MAX: 4,
  },
  SECTOR: {
    [0.2 * sqmInSqKm]: 2.8,
    [0.3 * sqmInSqKm]: 3,
    [0.4 * sqmInSqKm]: 3.2,
    [0.7 * sqmInSqKm]: 3.5,
    [1 * sqmInSqKm]: 4,
    [10 * sqmInSqKm]: 4.5,
    [25 * sqmInSqKm]: 5,
    [50 * sqmInSqKm]: 8,
    [100 * sqmInSqKm]: 20,
    MAX: 1000,
  },
  POSTCODE: {
    MAX: 100,
  },
};
